import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class SocmedService {
    // tiktok tools
    getAllTiktok() {
        return axios.get(API_URL + 'socmed/tk', { headers: authHeader() });
    }
    detailTiktok(id) {
        return axios.get(API_URL + 'socmed/tk/' + id, { headers: authHeader() });
    }

    updateTiktok(id, data) {
        return axios.patch(API_URL + 'socmed/tk/' + id, data, { headers: authHeader() });
    }
    deleteTiktok(id) {
        return axios.delete(API_URL + 'socmed/tk/' + id, { headers: authHeader() });
    }
    deleteBulkTiktok(data) {
        return axios.post(API_URL + 'socmed/tk/bulk-delete', data, { headers: authHeader() });
    }


    // twitter tools
    getTrends() {
        return axios.get(API_URL + 'socmed/tw/trends', { headers: authHeader() });
    }
    getAllTwitter() {
        return axios.get(API_URL + 'socmed/tw', { headers: authHeader() });
    }
    getDetailTwitter(id) {
        return axios.get(API_URL + 'socmed/tw/' + id, { headers: authHeader() });
    }
    deleteTwitter(id) {
        return axios.delete(API_URL + 'socmed/tw/' + id, { headers: authHeader() });
    }
    deleteBulkTwitter(data) {
        return axios.post(API_URL + 'socmed/tw/bulk-delete', data, { headers: authHeader() });
    }
    pinTwitter(id) {
        return axios.get(API_URL + 'socmed/tw/pin/' + id, { headers: authHeader() });
    }
    unpinTwitter(id) {
        return axios.get(API_URL + 'socmed/tw/unpin/' + id, { headers: authHeader() });
    }


    // instagram tools
    getAllInstagram() {
        return axios.get(API_URL + 'socmed/ig', { headers: authHeader() });
    }
    getDetailInstagram(id) {
        return axios.get(API_URL + 'socmed/ig/' + id, { headers: authHeader() });
    }
    deleteInstagram(id) {
        return axios.delete(API_URL + 'socmed/ig/' + id, { headers: authHeader() });
    }
    deleteBulkInstagram(data) {
        return axios.post(API_URL + 'socmed/ig/bulk-delete', data, { headers: authHeader() });
    }
    pinInstagram(id) {
        return axios.get(API_URL + 'socmed/ig/pin/' + id, { headers: authHeader() });
    }
    unpinInstagram(id) {
        return axios.get(API_URL + 'socmed/ig/unpin/' + id, { headers: authHeader() });
    }

    // facebook tools
    getAllFacebook() {
        return axios.get(API_URL + 'socmed/fb', { headers: authHeader() });
    }
    // getDetailFacebook(id) {
    //     return axios.get(API_URL+'socmed/fb/'+id, { headers: authHeader() });
    // }
    deleteFacebook(id) {
        return axios.delete(API_URL + 'socmed/fb/' + id, { headers: authHeader() });
    }
    // deleteBulkFacebook(data) {
    //     return axios.post(API_URL+'socmed/fb/bulk-delete', data, { headers: authHeader() });
    // }


    getOtherSitesTarget(data) {
        return axios.post(API_URL + 'socmed/os/by-target', data, { headers: authHeader() });
    }


    // ======================  update  ========================
    updatePrivateData(id, data) {
        return axios.patch(API_URL + 'socmed/pdt/' + id, data, { headers: authHeader() });
    }
    updatePrivateWeb(id, data) {
        return axios.patch(API_URL + 'socmed/pwb/' + id, data, { headers: authHeader() });
    }
    updateTwitter(id, data) {
        return axios.patch(API_URL + 'socmed/tw/' + id, data, { headers: authHeader() });
    }
    updateFacebook(id, data) {
        return axios.patch(API_URL + 'socmed/fb/' + id, data, { headers: authHeader() });
    }
    updateTelegram(id, data) {
        return axios.patch(API_URL + 'socmed/tl/' + id, data, { headers: authHeader() });
    }
    updateInstagram(id, data) {
        return axios.patch(API_URL + 'socmed/ig/' + id, data, { headers: authHeader() });
    }
    updateYoutube(id, data) {
        return axios.patch(API_URL + 'socmed/yt/' + id, data, { headers: authHeader() });
    }
    updateTiktok(id, data) {
        return axios.patch(API_URL + 'socmed/tk/' + id, data, { headers: authHeader() });
    }
    updateCitizen(id, data) {
        return axios.patch(API_URL + 'socmed/ct/' + id, data, { headers: authHeader() });
    }
    updateOtherSite(id, data) {
        return axios.patch(API_URL + 'socmed/os/' + id, data, { headers: authHeader() });
    }

    // ======================  create  ========================
    createPrivateDataTarget(id, data) {
        console.log('data: ', id, data)
        return axios.post(API_URL + 'socmed/pdt-target/' + id, data, { headers: authHeader() });
    }
    createTwitter(data) {
        return axios.post(API_URL + 'socmed/tw', data, { headers: authHeader() });
    }
    createFacebook(data) {
        return axios.post(API_URL + 'socmed/fb', data, { headers: authHeader() });
    }
    createInstagram(data) {
        return axios.post(API_URL + 'socmed/ig', data, { headers: authHeader() });
    }
    createTiktok(data) {
        return axios.post(API_URL + 'socmed/tk', data, { headers: authHeader() });
    }
    createTelegram(data) {
        return axios.post(API_URL + 'socmed/tl', data, { headers: authHeader() });
    }
    createOtherSite(data) {
        return axios.post(API_URL + 'socmed/os', data, { headers: authHeader() });
    }
    createPrivateData(data) {
        return axios.post(API_URL + 'socmed/pdt', data, { headers: authHeader() });
    }

    // ======================  detail  ========================
    detailTwitter(id) {
        return axios.get(API_URL + 'socmed/tw/' + id, { headers: authHeader() });
    }

    // ============================   delete  ===================================
    deletePrivateData(id) {
        return axios.delete(API_URL + 'socmed/pdt/' + id, { headers: authHeader() });
    }
    deleteTelegram(id) {
        return axios.delete(API_URL + 'socmed/tl/' + id, { headers: authHeader() });
    }

    deleteOtherSites(id) {
        return axios.delete(API_URL + 'socmed/os/' + id, { headers: authHeader() });
    }
}

export default new SocmedService();
